import { render, staticRenderFns } from "./UnsubscribeEmail.vue?vue&type=template&id=627b8a29&scoped=true&"
import script from "./UnsubscribeEmail.vue?vue&type=script&lang=js&"
export * from "./UnsubscribeEmail.vue?vue&type=script&lang=js&"
import style0 from "./UnsubscribeEmail.vue?vue&type=style&index=0&id=627b8a29&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627b8a29",
  null
  
)

export default component.exports